import { DashboardContext } from 'live/context/dashboard'
import React, { ComponentType, Props, PropsWithChildren, useContext } from 'react'
import { ThemeProvider, useTheme } from 'styled-components'

import liveTheme from 'live/services/theme'
import { darkTheme as intelieDarkTheme, theme as intelieLightTheme } from '@intelie/ui'
const lightTheme = { ...intelieLightTheme, ...liveTheme }
const darkTheme = { ...intelieDarkTheme, ...liveTheme }

export function themeAwareWidgetDecorator<P>(Component: ComponentType<P>): ComponentType<P> {
    return function ThemeAwareWidget(props: P): JSX.Element {
        const theme = useTheme()
        const dashboardContext = useContext(DashboardContext)

        if (theme?.['gray-100']) {
            return <Component {...props} />
        }

        if (dashboardContext.theme === 'dark') {
            return (
                <ThemeProvider theme={darkTheme}>
                    <Component {...props} />
                </ThemeProvider>
            )
        }

        return (
            <ThemeProvider theme={lightTheme}>
                <Component {...props} />
            </ThemeProvider>
        )
    }
}
